import { render, staticRenderFns } from "./ClienteContato.vue?vue&type=template&id=64640371&"
import script from "./ClienteContato.vue?vue&type=script&lang=js&"
export * from "./ClienteContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports